import { wrapSyncFunc } from '../util';
export var required = wrapSyncFunc(function (rule, value) {
  var required = rule.required;

  if (!required) {
    return;
  }

  return Boolean(Array.isArray(value) && value.length) || !Array.isArray(value) && value != null && value !== '';
});